import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, XCircle } from 'lucide-react';
const faqs = [{
  q: '¿El producto es digital?',
  a: 'Sí. Todo el material es digital en formato PDF.'
}, {
  q: '¿Cómo recibo el material?',
  a: 'Recibís acceso inmediato luego de la compra.'
}, {
  q: '¿Puedo verlo desde el celular?',
  a: 'Sí. Podés acceder desde celular, tablet o computadora.'
}, {
  q: '¿Incluye todos los recursos?',
  a: 'Sí. Incluye ebook principal, kit PPI y kit de herramientas profesionales.'
}, {
  q: '¿Los materiales son editables?',
  a: 'Sí. Incluye recursos editables e imprimibles.'
}, {
  q: '¿Cuánto tiempo tengo acceso?',
  a: 'El acceso es de por vida.'
}];
const painPoints = ['Meses de inseguridad profesional', 'Entrevistas con dudas constantes', 'Informes que llevan horas', 'Desgaste emocional innecesario', 'Sensación de no estar preparada', 'Improvisar intervenciones todo el tiempo', 'Falta de organización clínica', 'Más ansiedad y menos claridad', 'El mismo miedo cada vez que aparece un caso nuevo'];
function FAQItem({
  q,
  a
}: {
  q: string;
  a: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-slate-200 last:border-0" data-id="element-11">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex items-center justify-between text-left focus:outline-none" aria-expanded={isOpen} data-id="element-12">
        <span className="font-bold text-navy-900 text-lg pr-8" data-id="element-13">{q}</span>
        <ChevronDown className={`w-5 h-5 text-slate-400 transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-14" />
      </button>
      <AnimatePresence data-id="element-15">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-16">
            <p className="pb-6 text-slate-600" data-id="element-17">{a}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  return <div className="bg-white py-24" data-id="element-18">
      {/* FAQ */}
      <section className="container mx-auto px-4 max-w-3xl mb-32" data-id="element-19">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-navy-900 text-center mb-12 uppercase tracking-tight" data-id="element-20">
          ❓ Lo que más nos preguntan
        </h2>
        <div className="bg-slate-50 rounded-3xl p-6 md:p-10 border border-slate-100" data-id="element-21">
          {faqs.map((faq, i) => <FAQItem key={i} {...faq} data-id="element-22" />)}
        </div>
      </section>

      {/* Comparison / Cost of inaction */}
      <section className="container mx-auto px-4 max-w-4xl" data-id="element-23">
        <div className="text-center mb-12" data-id="element-24">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-navy-900 uppercase tracking-tight mb-4" data-id="element-25">
            ⚖️ ¿Cuánto cuesta seguir improvisando en clínica?
          </h2>
        </div>

        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-lg border border-slate-100 max-w-2xl mx-auto mb-16 relative overflow-hidden" data-id="element-26">
          <div className="absolute top-0 left-0 w-full h-2 bg-red-400" data-id="element-27" />
          <h3 className="font-bold text-slate-400 uppercase tracking-widest mb-8 text-center text-sm" data-id="element-28">
            Sin el megapack
          </h3>
          <div className="space-y-4" data-id="element-29">
            {painPoints.map((point, i) => <div key={i} className="flex items-center gap-3" data-id="element-30">
                <XCircle className="w-5 h-5 text-red-300 shrink-0" data-id="element-31" />
                <span className="text-slate-600 font-medium" data-id="element-32">{point}</span>
              </div>)}
          </div>
        </div>

        <div className="text-center" data-id="element-33">
          <p className="font-serif italic text-2xl md:text-3xl text-teal-600 max-w-3xl mx-auto leading-relaxed" data-id="element-34">
            "El próximo paso en tu práctica puede empezar hoy."
          </p>
        </div>
      </section>
    </div>;
}